(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/cms-document/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/cms-document/assets/javascripts/prescript.js'); 
var svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.cms_document = svs.accountservices.cms_document || {};

 })(window);